import { render, staticRenderFns } from "./ChatAdmin.vue?vue&type=template&id=7763099a&scoped=true"
import script from "./ChatAdmin.vue?vue&type=script&lang=js"
export * from "./ChatAdmin.vue?vue&type=script&lang=js"
import style1 from "./ChatAdmin.vue?vue&type=style&index=1&id=7763099a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763099a",
  null
  
)

export default component.exports